import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    updateVeridasUser
} from '../../../reduxToolkit/Visitor/VisitorApi';
import { toast } from 'react-toastify';
import HandleChange from '../../../Helpers/HandleChange';
import {TAB_INDEX} from '../../Dashboard/Visitor/External/Model/Model';
import {getFailedUrl, getMainUrl, MODEL_VERIDAS} from '../Model/Models';
import useHandleBeforeUnload from './useHandleBeforeUnload';
import useBackNavigation from './useBackNavigation';
import {GetInvitationById} from "../../../reduxToolkit/Invitation/InvitationApi";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const SuccessValidationFormApp = () => {

    const { id, guardFlowId, userId, eventId } = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const userDataSuccess = useSelector((state) => state.VisitorSlice.userDataDocument);
    const validationData = useSelector((state) => state.VisitorSlice.getValidationId);
    const { getInvitationById } = useSelector((state) => state.InvitationSlice);
    const [modifiedData, setModifiedData] = useState({ ...MODEL_VERIDAS });
    const [loading, setLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(1);
    const [isValidDocumentId, setIsValidDocumentId] = useState(true);
    const { handleChange } = HandleChange({ model: modifiedData, setModel: setModifiedData });
    const invitationId = getInvitationById?.invitation?.id;
    const mainUrl = getMainUrl({ invitationId, guardFlowId, userId, eventId });
    const failedUrl = getFailedUrl({ invitationId, guardFlowId, userId, eventId });
    const resolvedUserId  = userId ? userId: getInvitationById?.invitation?.visitorId;

    /**
     * Effect to set the data.
     */
    useEffect(() => {
        if (userDataSuccess) {
            setModifiedData(modifiedData.set(userDataSuccess));
        }
    }, [userDataSuccess]);

    useEffect(() => {
        validateDocumentId();
    }, [modifiedData.documentId]);

    /**
     * Function to update data and validate the data obtained from the API.
     */
    const handleSubmit = () => {
        if (activeStep === TAB_INDEX.TWO) {
            navigate(mainUrl);
            return;
        }
        if(!modifiedData?.isValid() || !isValidDocumentId){
            return;
        }

        setActiveStep(2);
        setLoading(true);
        if (JSON.stringify(modifiedData) !== JSON.stringify(userDataSuccess)) {
            const payload = {
                userId: resolvedUserId,
                validationId: validationData,
                ocrAndScoresResponse: {
                    ...modifiedData,
                    dob: new Date(modifiedData.dob).getTime(),
                },
            };

            dispatch(updateVeridasUser(payload)).then(({ payload: { data: { code, success } } }) => {
                handleResponse(code, success);
            });
        } else {
            dispatch(
                updateVeridasUser({
                    userId: resolvedUserId,
                    validationId: validationData,
                    ocrAndScoresResponse: userDataSuccess,
                })
            ).then(({ payload: { data: { code, success } } }) => {
                handleResponse(code, success);
            });
        }
    };

    /**
     * Control of the response to the request
     * @param success
     * @param code
     */
    const handleResponse = (success, code) => {
        if (success) {
            toast.success(t('validation_successful'));
            dispatch(GetInvitationById(id));
        } else {
            navigate(failedUrl);
            toast.error(t('validation_failed') + `: ${t(`errorCode.${code}`)}`);
        }
        setLoading(false);
    }

    /**
     * handle to validate document id
     */
    const validateDocumentId = () => {
        if(modifiedData.documentId !== '' && modifiedData.documentId != null && typeof modifiedData.documentId != 'undefined'){
            setIsValidDocumentId(isSameDocumentLength(modifiedData.documentId));
        }else{
            setIsValidDocumentId(true);
        }
    };

    const isSameDocumentLength = (value) => {
        return value.length === modifiedData.documentIdOriginal.length
    };

    const validateDocumentIdChanges = (e) => {

        const inputType = e.nativeEvent?.inputType;

        const isDelete =
            inputType === 'deleteContentBackward' ||
            inputType === 'deleteContentForward';

        // Prevent deleting more than allowed
        if (isDelete && modifiedData.maxDeletes <= 0) {
            return;
        }

        // Prevent adding more than allowed
        if (!isDelete && modifiedData.maxChanges <= 0) {
            return;
        }

        handleChange(e);

        setModifiedData(prev => {

            // Add valid character
            if (!isDelete) {
                return {
                    ...prev,
                    maxChanges: prev.maxChanges - 1
                };
            }

            // Delete character
            return {
                ...prev,
                maxDeletes: prev.maxDeletes - 1
            };
        });
    };

    useBackNavigation({ getInvitationById, validationId: validationData });
    useHandleBeforeUnload({ getInvitationById , validationId: validationData});

    return {
        id,
        guardFlowId,
        t,
        modifiedData,
        activeStep,
        loading,
        handleSubmit,
        handleChange,
        isValidDocumentId,
        validateDocumentIdChanges
    }

}

export default SuccessValidationFormApp
